<ng-container *ngIf="isInitialized" [formGroup]="formGroup">
  <div class="row p-2" *ngIf="showPortData() && !isFullLegOnly">
    <div class="col-6">
      <div class="row pb-2">
        <label class="col-3 mt-2 text-end mogo-bold" >MT 
          <span *ngIf="isInboundJob()">Dehire</span>
          <span *ngIf="!isInboundJob()">Collect</span> Point:</label>
        <div class="col-9">
          <ng-select id="mtDropdown" formControlName="mtLocation" [items]="availableMtLocations" bindLabel="display"
                [placeholder]="'Select MT ' + (isInboundJob() ? 'Dehire' : 'Collect') + ' Point'">

                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="text-md-start">
                    {{ item.display }}
                  </div>
              </ng-template>
            </ng-select>
        </div>
      </div>

      <div class="row pb-2" *ngIf="doesControlExist('mtRequestedDeliveryDate')">
        <label class="col-3 mt-2 text-end mogo-bold" >MT Requested Delivery Date:</label>
        <div class="col-9">
            <app-custom-date-range-picker id="mtDeliveryDate" [formControl]="getFormPartial('mtRequestedDeliveryDate')"
                placeholder="Select date">
            </app-custom-date-range-picker>

            <small class="text-start"
                *ngIf="formGroup.get('mtRequestedDeliveryDate')!.invalid">
                <div *ngIf="formGroup.get('mtRequestedDeliveryDate')!.hasError('dateNotLess')" class="text-danger">
                    The MT requested delivery date must be on or after vessel ETA and the full requested date.
                </div>
                <div *ngIf="formGroup.get('mtRequestedDeliveryDate')!.hasError('dateNotGreater')" class="text-danger">
                    The MT requested delivery date must be on or before the vessel ETD and the full requested date.
                </div>
            </small>
        </div>
      </div>

      <div class="row pb-2" *ngIf="doesControlExist('mtRequestedDeliveryDate')">
        <label class="col-3 mt-2 text-end mogo-bold" >{{isInboundJob() ? 'Acceptance' : 'Release'}} Number:</label>
        <div class="col-9">
          <input type="text" class="form-control text-capitalize" formControlName="releaseAcceptNo"
            [placeholder]="'Enter ' + (isInboundJob() ? 'Acceptance' : 'Release') + ' Number'" />
        </div>
      </div>

      <div class="row pb-2" *ngIf="doesControlExist('mtRequestedDeliveryDate')">
        <label class="col-3 mt-2 text-end mogo-bold" >Is Active:</label>
        <div class="col-1">
          <input type="checkbox" formControlName="releaseAcceptActive" />
        </div>
      </div>
    </div>
  </div>

</ng-container>
